import React from 'react';

export const ScoreContent = ({ title, summary, className, children }) => {
  return (
    <div className={`score-content ${className}`}>
        <h3 className="h3-navy-blue">{title} grade details</h3>
        <p className="text-04-navy-blue">{summary}</p>
        <div className="ar-cost tab-print">
      </div>
        <div className="sub-components">{children}</div>
    </div>
  )
}
